module.exports = __webpack_public_path__ + "img/c05_unitcretanbowman_Normal_ua.cebcda6a.webp";